module.exports = __webpack_public_path__ + "static/after-883cfa644b6376a1e82c5951b5a2ee86.png";